import axios from '@/components/api/axios';

async function cancel() {
  const res = await axios.axiosPost('/api/cancelAccount/cancel', null);
  return res;
}

async function getStatus() {
  const res = await axios.axiosGet('/api/cancelAccount/getStatus', null);
  return res;
}


export default {
  cancel,
  getStatus
}



// WEBPACK FOOTER //
// ./src/components/api/account/cancel.js